import React from 'react';
import PropTypes from 'prop-types';
import TrackingParamsContainer from '../../../redux/containers/TrackingParamsContainer';
import PageHeader from '../../PageHeader/PageHeader';
import UnderMaintenanceBanner from '../Banner/UnderMaintenanceBanner';
import AddressSearchLoadingContainer from '../../../redux/containers/AddressSearchLoadingContainer';
import AddressSearchMessagesContainer from '../../../redux/containers/AddressSearchMessagesContainer';
import PlansContainer from '../../../redux/containers/PlansContainer';

class Home extends React.Component {
  componentDidMount() {
    const {
      isAddressSelected,
      storeStaticConfig,
      fetchOrderInfo,
      uuid
    } = this.props;
    if (uuid) {
      fetchOrderInfo(uuid, isAddressSelected);
      storeStaticConfig();
    } else {
      // if (addressId && !isAddressSelected) {
      //   fetchAddress({ id: addressId }, false, planId);
      //   storeStaticConfig();
      // }
      // if (planId) {
      //   setSelectedPlan(planId);
      // }
    }
  }

  render() {
    const { isUnderMaintenance } = this.props;
    return (
      <main>
        <TrackingParamsContainer {...this.props} />
        {isUnderMaintenance &&
          <UnderMaintenanceBanner />
        }
        {!isUnderMaintenance &&
          <PageHeader title={'Choose Contract Options'} />
        }
        <section className="address-search">
          <div className="container">
            <div className="row">
              <div className="col-sm-12 col-md-9">
                <AddressSearchLoadingContainer />
                <AddressSearchMessagesContainer isChange={false} />
              </div>
            </div>
          </div>
        </section>
        <PlansContainer />
      </main>
    );
  }
}

Home.defaultProps = {
  isUnderMaintenance: false
};

Home.propTypes = {
  isUnderMaintenance: PropTypes.bool.isRequired,
  isAddressSelected: PropTypes.bool.isRequired,
  storeStaticConfig: PropTypes.func.isRequired,
  uuid: PropTypes.string.isRequired,
  fetchOrderInfo: PropTypes.func.isRequired,
};

export default Home;



/** WEBPACK FOOTER **
 ** ./src/components/home/Home/Home.js
 **/